const VIEW_TYPE = {
  CARD: 'CARD',
  ACCORDION: 'ACCORDION',
};

export { VIEW_TYPE };
